import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

import { postRequest } from 'utils/redux-saga';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { WORKSHEET_LOAD_REQUESTED } from './constants';
import {
    setWorksheet,
    succeededLoadWorksheet,
    failedLoadWorksheet
} from './actions';

import { RequestLoadWorksheetAction } from './types';

export function* loadWorksheet(
    action: RequestLoadWorksheetAction
): SagaIterator {
    const organizationId = yield select(selectCurrentOrganizationId);

    try {
        const { date, operatorPersonId, type } = action.payload;

        const response = yield call(postRequest, 'Worksheets', {
            date,
            operatorPersonId,
            organizationId,
            type
        });

        if (response) {
            yield all([
                put(setWorksheet(response.data)),
                put(succeededLoadWorksheet(response))
            ]);
        }
    } catch (error) {
        yield put(failedLoadWorksheet(error));
    }
}

export function* watchWorksheetLoadRequested(): SagaIterator {
    yield takeLatest(WORKSHEET_LOAD_REQUESTED, loadWorksheet);
}

export default function* worksheetSagas(): SagaIterator {
    yield all([fork(watchWorksheetLoadRequested)]);
}
